import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, ResponsiveContainer } from 'recharts';
import { ANALYSIS_RATINGS } from '../../types/analysis';

interface AnalysisChartProps {
  ratings: {
    crumbStructure: number;
    ovenSpring: number;
    crust: number;
    crumbTexture: number;
  };
}

export function AnalysisChart({ ratings }: AnalysisChartProps) {
  const data = ANALYSIS_RATINGS.map(rating => ({
    subject: rating.label,
    value: ratings[rating.name as keyof typeof ratings]
  }));

  return (
    <div className="w-full max-w-md h-[300px]">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
          <PolarGrid stroke="#ffffff20" />
          <PolarAngleAxis
            dataKey="subject"
            tick={{ fill: '#ffffff80', fontSize: 12 }}
          />
          <Radar
            name="Bread Analysis"
            dataKey="value"
            stroke="#d97706"
            fill="#d97706"
            fillOpacity={0.3}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}